import { c as _c } from "react/compiler-runtime";
import { type DetailedStore, type DetailedStoreWithDistance } from '../interfaces';
import React, { Dispatch, ReactElement, SetStateAction, memo } from 'react';
import { getStoreQueryLinkParams, getStoreSlug } from '@spa/lib/storeSlug';
import ButtonComponent from '../../button/button/button.component';
import { ButtonType } from '../../button/types/ButtonType';
import { ConditionalButton } from '@spa/components/button/conditional-button/conditional-button';
import { LinkTarget } from '@spa/lib/react/hooks/useLinkAttributes';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import PickupInfoComponent from '../pickup-info/pickup-info.component';
import StoreStockInfoComponent from '@spa/components/storefinder/store-stock-info/store-stock-info.component';
import styles from './store-tile.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export interface StoreTileComponentProps {
  readonly isHomepage: boolean;
  readonly isSelectedStore: boolean;
  readonly productCode: string | null;
  readonly storefinderSearchTerm?: string | null;
  readonly store: DetailedStoreWithDistance;
  readonly setSelectedStore: (newSelectedStore: DetailedStore) => void;
  readonly setShownStore: Dispatch<SetStateAction<DetailedStore | null>>;
  readonly setShowStoreFinderPopup?: (show: boolean) => void;
}
function StoreTileComponent(t0) {
  const $ = _c(68);
  const {
    isHomepage,
    isSelectedStore,
    productCode,
    storefinderSearchTerm,
    setSelectedStore,
    setShownStore,
    setShowStoreFinderPopup,
    store
  } = t0;
  const {
    formatMessage
  } = useNamespacedIntl("storefinder");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function formatDistance(value) {
      const formattedDistance = parseFloat(value.toFixed(1)).toString();
      return `${formattedDistance}km`;
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const formatDistance = t1;
  let t2;
  if ($[1] !== setSelectedStore || $[2] !== setShowStoreFinderPopup || $[3] !== setShownStore) {
    t2 = function handleOnClick(store_0) {
      setSelectedStore(store_0);
      if (setShowStoreFinderPopup) {
        setShowStoreFinderPopup(false);
      } else {
        setShownStore(store_0);
      }
    };
    $[1] = setSelectedStore;
    $[2] = setShowStoreFinderPopup;
    $[3] = setShownStore;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleOnClick = t2;
  const showPickupTime = !productCode && !isHomepage && store.storePickUp;
  let t3;
  if ($[5] !== store.name) {
    t3 = <span className="bold">{store.name}</span>;
    $[5] = store.name;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== store.address.street) {
    t4 = <span>{store.address.street}</span>;
    $[7] = store.address.street;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== store.address.town || $[10] !== store.address.zip) {
    t5 = <span>{store.address.zip} {store.address.town}</span>;
    $[9] = store.address.town;
    $[10] = store.address.zip;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <div className={styles["store-tile__store-details"]}>{t3}{t4}{t5}</div>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== store.distance) {
    t7 = store.distance && <span className="bold">{formatDistance(store.distance)}</span>;
    $[16] = store.distance;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = <div className={styles["store-tile__store-info"]}>{t6}{t7}</div>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== showPickupTime || $[22] !== store.pickupTime) {
    t9 = showPickupTime && store.pickupTime && <PickupInfoComponent time={store.pickupTime} />;
    $[21] = showPickupTime;
    $[22] = store.pickupTime;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== productCode || $[25] !== store.code) {
    t10 = productCode && <StoreStockInfoComponent productCode={productCode} storeCode={store.code} />;
    $[24] = productCode;
    $[25] = store.code;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  const t11 = !isHomepage;
  let t12;
  if ($[27] !== formatMessage || $[28] !== store.name) {
    t12 = formatMessage("moreDetailsOnStore", {
      store: store.name
    });
    $[27] = formatMessage;
    $[28] = store.name;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t12) {
    t13 = <span className="sr-only">{t12}</span>;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== formatMessage) {
    t14 = formatMessage("moreDetails");
    $[32] = formatMessage;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t13 || $[35] !== t14) {
    t15 = <>{t13}{t14}</>;
    $[34] = t13;
    $[35] = t14;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== setShownStore || $[38] !== store) {
    t16 = () => setShownStore(store);
    $[37] = setShownStore;
    $[38] = store;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== store) {
    t17 = getStoreSlug(store);
    $[40] = store;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  const t18 = `/s/${t17}`;
  let t19;
  if ($[42] !== storefinderSearchTerm) {
    t19 = getStoreQueryLinkParams(storefinderSearchTerm);
    $[42] = storefinderSearchTerm;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== t18 || $[45] !== t19) {
    t20 = {
      type: "internal",
      resolved: true,
      linkTitle: null,
      path: t18,
      target: LinkTarget.SELF,
      linkParams: t19,
      anchorTarget: null
    };
    $[44] = t18;
    $[45] = t19;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== t11 || $[48] !== t15 || $[49] !== t16 || $[50] !== t20) {
    t21 = <ConditionalButton condition={t11} buttonType={ButtonType.AS_TEXT} text={t15} onButtonClick={t16} link={t20} />;
    $[47] = t11;
    $[48] = t15;
    $[49] = t16;
    $[50] = t20;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  const t22 = isSelectedStore ? "selectedStore" : "selectStore";
  let t23;
  if ($[52] !== formatMessage || $[53] !== t22) {
    t23 = formatMessage(t22);
    $[52] = formatMessage;
    $[53] = t22;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  let t24;
  if ($[55] !== handleOnClick || $[56] !== store) {
    t24 = () => handleOnClick(store);
    $[55] = handleOnClick;
    $[56] = store;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  let t25;
  if ($[58] !== isSelectedStore || $[59] !== t23 || $[60] !== t24) {
    t25 = <ButtonComponent buttonType={ButtonType.SECONDARY} text={t23} disabled={isSelectedStore} onClick={t24} />;
    $[58] = isSelectedStore;
    $[59] = t23;
    $[60] = t24;
    $[61] = t25;
  } else {
    t25 = $[61];
  }
  let t26;
  if ($[62] !== t10 || $[63] !== t21 || $[64] !== t25 || $[65] !== t8 || $[66] !== t9) {
    t26 = <div className={styles["store-tile"]}>{t8}{t9}{t10}{t21}{t25}</div>;
    $[62] = t10;
    $[63] = t21;
    $[64] = t25;
    $[65] = t8;
    $[66] = t9;
    $[67] = t26;
  } else {
    t26 = $[67];
  }
  return t26;
}
export default memo(StoreTileComponent);